const Form032EN = {
    stepName: {
        importantNotes: "Important Notes",
        applicationInfor: "Application Information",
        confirmation: "Confirmation",
    },

    importantNotesContent: {
        // Form 32
        note1: "Reference Materials:",
        note2: "EDB Circular Nos. {{primaryCircularNo}} (NET Scheme in Primary Schools)",
        note3: "{{primaryReferLink}}",

        note4: "EDB Circular Nos. {{secondaryCircularNo}}  (Enhanced NET Scheme in Secondary Schools)",
        note5: "{{secondaryReferLink}}",

        note6: '"Sample Memorandum on the Terms and Conditions of Service for Appointment as Teachers under the NET Scheme in Primary Schools / the Enhanced NET Scheme in Secondary Schools (applicable to {{schYear}} school year)"',
        note7: "Primary Schools:",
        note8: "{{primaryLink}}",
        note9: "Secondary Schools:",
        note10: "{{secondaryLink}}",

        title: "Notes",
    },

    sectionOne: {
        primaryOrSecondaryOption: {
            primary:
                "Native-speaking English Teacher (NET) Scheme in Primary Schools Application for Reimbursement of Medical Insurance Premium Payment ",
            secondary:
                "Enhanced Native-speaking English Teacher (NET) Scheme in Secondary Schools Application for Reimbursement of Medical Insurance Premium Payment",
        },

        aidedOrCaputOption: {
            aided: "Aided school / special school",
            caput: "Caput school",
        },
        perTitleOption: {
            Mr: "Mr",
            Mrs: "Mrs",
            Ms: "Ms",
            Miss: "Miss",
        },
        perMaritalStuOption: {
            single: "single",
            accompanied: "married, accompanied by spouse",
            unaccompanied: "married, unaccompanied by spouse",
            separated: "separated",
            widowed: "widowed",
            divorced: "divorced",
        },

        title: "Section 1: Personal Particulars",
        primaryOrSecondary: "Application for",
        aidedOrCaput: "School Type",

        perTitle: "Full name of applicant:",
        perGivenName: "Given names",
        perSurname: "Surname",
        perNationality: "Nationality/Nationalities held:",
        perPassportNum: "Passport number:",
        perHKIC: "Hong Kong Identity Card number:",
        perMaritalStu: "Marital status:",
        perSpouseTitle: "Full name of spouse:",
        perSpouseOccupation: "Spouse's occupation:",
        perSpouseEmployer: "Spouse's employer:",
    },

    applicationInformationContent: {
        title: "Section 2: Details of Insurance Policy",
        label: {
            part2Title:
                "Section 4: Certification by Applicant's School (To be completed by aided schools/special schools with {{schoolType}} section only)",

            part3Title:
                "Section 5: Certification by Applicant's School (to be completed and retained by caput schools)",

            primaryOrSecondary: "Application for",
            primaryOrSecondaryOption: {
                primary:
                    "Native-speaking English Teacher (NET) Scheme in Primary Schools Application for Reimbursement of Medical Insurance Premium Payment ",
                secondary:
                    "Enhanced Native-speaking English Teacher (NET) Scheme in Secondary Schools Application for Reimbursement of Medical Insurance Premium Payment",
            },

            label3: "1. Details of the insurance policy:",
            nameOfInsurance: "(a) Name of the Insurance Company",

            label4: "Details of family members in Hong Kong insured:",
            familyMembers: "(b) Details of family members in Hong Kong insured",
            label5: "(c) Insured period (i.e. the period covered by the policy)",
            fromDate: "From",
            toDate: "to",

            label6: "2. I attach herewith the receipt(s) of my medical insurance premium payment at a total of",
            currencyOption: {
                hkd: "Hong Kong Dollar",
                other: "Other currency",
            },

            // my spouse info
            nameOfSpouse: "Full name of my spouse",
            hkidSpouse: "Hong Kong Identity Card Number (if any)",

            declareOfSpouse1:
                "I declare that my spouse of particulars stated above",
            declareOfSpouse2:
                "employed under the Enhanced NET Scheme in Secondary Schools or the NET Scheme in Primary Schools. If the answer is in the affirmative, please provide the employment details of your spouse as specified below:",

            isOption: {
                is: "is",
                isNot: "is not",
            },

            nameOfSchool: "Name of school",
            spouseContractFrom: "Contract period from",
            spouseContractTo: "to",

            // family member table
            familyMemberGp: {
                name: "Name",
                relationship: "Relationship",
                dateOfBirth: "Date of birth",
            },
            relationship: {
                husband: "Husband",
                wife: "Wife",
            },

            // last section for personal info
            fullNameOfNET: "Full name of NET",
            hkid: "Hong Kong Identity Card Number (Mandatory to be provided once available)",
        },

        // FormA
        part2Label: {
            address1: "Secretary for Education",
            address2: "[Attn: NET Administration Team, Eduction Bureau]",
            address3:
                "Room W304, 3/F, West Block, EDB Kowloon Tong Education Services Centre,",
            address4: "19 Suffolk Road, Kowloon Tong, Kowloon",
            // address5: "Wanchai, Hong Kong",

            p1_1: "I certify that the applicant",
            p1a_1: "is appointed as a Native-speaking English Teacher under the Enhanced NET Scheme in {{schoolType}} Schools in my school from",
            p1a_2: "(For the contract renewed/appointment contract period extended, the previous appointment/extension contract period is from",

            p1b_1: "is eligible for reimbursement of medical insurance premium payment at the",
            marriageOption: {
                single: "single",
                married: "married",
            },
            p1b_2: "rate; and",

            applyOption: {
                applied: "have applied",
                notApplied: "have not applied",
            },
            p1c_1: "for reimbursement of medical insurance premium payment for the",
            p1c_2: "school year as specified in paragraph 1 of Section 3.",

            //for point 2
            p2_1: "The grant of reimbursement of medical insurance premium payment for the period from",
            p2_2: "in the amount of ",
            p2_3: " is approved. I should be grateful if you would arrange the payment.",
            p2_declare:
                "<b>**If the coverage period of the insurance begins before or extends beyond the NET’s contract period, reimbursement of the medical insurance premium will be made on a pro-rata basis, up to the maximum amount specified in the contract.</b> For example, if the insurance premium costing HK$1,500 covers an insured period from 1.10.2013 to 30.9.2014 but the NET’s contract expires on 15.8.2014, the amount to be reimbursed will be HK$1,500 (HK$1500 ÷ 365 days × 319 days) for the period from 1.10.2013 to 15.8.2014.",

            //for point 3
            p3: "I certify that relevant receipts have been sighted by me and are kept in the school for record purpose.",
        },

        part4Label: {
            p1_1: "I confirm that",
            p1_2: "has already established that his/her normal place of residence as outside Hong Kong and he/she is entitled to receive the reimbursement of Medical Insurance Premium in the amount of",
        },

        supervisorInfo: {
            date: "Date",
            nameOfSupervisor: "Name of",
            supervisorOption: {
                supervisor: "Supervisor",
                schoolHead: "Principal",
            },

            titleOption: {
                mr: "Mr.",
                mrs: "Mrs.",
                ms: "Ms.",
                miss: "Miss.",
            },

            nameOfSchool: "Name of school",
            schoolCode: "School code",
            schoolAddress: "School address",

            faxNo: "Fax no.",
            telNo: "Tel. no.",
            contactPerson: "Contact person for enquiry",
            post: "Post of contact person",
        },

        errorMsg: {
            nameOfApplicationEn: "name of applicant in English",
            nameOfApplicationCh: "name of applicant in Chinese",
            schoolName: "name of school in English",
            currencyUnit: "currency unit",

            //for declaration info (Part I)
            givenName: "given name",
            surname: "surname",

            // for HKIC
            hkic: "Please input a valid Hong Kong identity card number",

            //for validate msg
            afterFrom: "The year should be after start school year",
            beforeYearFrom:
                "The year should be before the current start school year",
            afterPreviousFrom:
                "The year should be after the start year of previous appointment",

            //for part II
            schoolAddress: "school address",
            schoolCode: "Please insert valid school code",

            name: "name",

            //for date validation
            afterFromDate: "The date should be after the start date",
            beforeFromDate:
                "The date should be before the start date of current appointment",
            afterOnFromDate:
                "The date should be on or after the start date of current appointment",
            beforeOnToDate:
                "the date should be on or before the end date of current appointment",
        },
    },

    sectionThree: {
        title: "Section 3: Declaration by Applicant and Spouse",
        toPrincipal: "To: Supervisor/Principal of",
        first: {
            label1: "I hereby apply for the reimbursement of medical insurance premium payment for",
            onlyMyself: "myself",
            withFamily: "and my family member(s)*",
            label2: "included in Section 2 for the",
        },
        titleOption: {
            i: "I",
            iSp: "I and my spouse",
            iAm: "I am",
            weAre: "we are",
            we: "we",
            We: "We",
            my: "my",
            My: "My",
            our: "our",
            Our: "Our",
            me: "me",
            us: "us",
        },
        two: "I confirm that I have read and understood the EDB Circular No. {{circularNo}} including the Notes for Completing {{type}}-Forms A-E and the stipulations related to Medical Allowance in the Memorandum on the Terms and  Conditions of Service. I agree to abide by the provisions of the Medical Allowance for Native-speaking English Teachers employed under the Enhanced NET Scheme in {{schType}} Schools.",
        three: "<b>{{isFamily}}</b>* declare that I and my family members included in this application are eligible for the Medical Allowance claimed and that <b>{{isMy}}</b>* not receiving <b>any medical benefit</b> arising from my employment with the school and my spouse's employment.",
        four: "<b>{{isFamily}}</b>* declare that the information provided in this application form is true and correct. <b>{{isMy1}}</b>* understand that if <b>{{isFamily}}</b>* give any false or incorrect information / declaration, <b>{{isMy}}</b>* will be subject to the consequences, including disqualification from all forms of fringe benefits under the NET Scheme, being required to refund the benefits to the Government, and being subject to disciplinary punishment and / or termination of contract and / or legal proceedings and / or criminal prosecution.",
        five: "I undertake to report to the school <b>within 30 days</b> any changes of my marital status and family particulars that might affect my entitlement to the Medical Allowance.",
        six: "I undertake to inform you and to cease drawing the Medical Allowance immediately once I and/or my spouse begin(s) to receive any form of medical benefits in cash or in kind under my / my spouse's terms of employment with an employer.",
        seven: "I agree to repay the Governemnt immediately if any overpayment of fringe benefits under the NET Scheme is made. The Government reserves the right to deduct from my Salaries and recover from my accrued benefits derived from voluntary contributions under any provident fund scheme any amount that it may have overpaid me, together with the interest accrued on such amount, as appropriate, from the date on which the overpayment was made to the date of deduction/the date that the amount is recovered, and all costs and expenses incurred in recovery. I also agree that the Government may set-off any sums due from me against any sums due to me.",
        eight: "<b>{{isMy1}}</b>* consent is hereby given to the EDB, in assessing my eligibility for the fringe benefits under the NET Scheme, to check and match <b>{{isMy}}</b>* personal data relating to this application (including but not limited to the personal data given on this application form and other relevant documents submitted) with <b>{{isMy}}</b>* personal data collected for any other purpose (whether it is by manual means). <b>{{isWe}}</b>* hereby authorise the EDB to approach other government departments, public/private organisations, or employer(s), landlord(s) or solicitor(s) concerned and expressly agree that they may give access to the EDB <b>{{isMy}}</b>* personal data they possess, so that the EDB can use such data for the purpose of processing my application, ascertaining my compliance with the rules of the NET Scheme and/or taking appropriate actions against <b>{{isUs}}</b>* if necessary.",
        nine: "<b>{{isWe}}</b>* agree that <b>{{isMy}}</b>* personal data relating to this application (including but not limited to the personal data given on this application form and other relevant documents submitted) can be used by the EDB in activities relating to the administration of the fringe benefits under the NET Scheme and may be disclosed to other connected bodies for such purposes.",
        ten: "I understand that it will not be possible to process my application if I fail to provide the information requested.",
        eleven: "<b>{{isWe}}</b>* have read, understand and agree to the Personal Information Collection Statement in the Appendix of this application form.",
        applicantFullName: "Full name of applicant",
        spoFullName: "Full name of spouse ",
        spouseSign: "Signature of spouse",
    },
};
export default Form032EN;
